export default __webpack_public_path__ + "static/media/027-speed limit.980a6068.png";